import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export class Source{
  public sourceId : number;
  public source : string;
  constructor(){}
}

@Injectable({
  providedIn: 'root'
})
export class SourceService {
  
  constructor(private httpClient:HttpClient) { }

  public getSourceList() {
    //let userEmail = sessionStorage.getItem('loginUserName');
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<Source[]>('/api/v1/source/',{headers}).pipe(catchError(this.errorHandler));
  }

  public createSource(obj : any) : Observable<any>{
    //console.log(obj);
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/source/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  updateSource(bean: Source): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/source/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  deleteSource(Id: number){
    return this.httpClient.delete('api/v1/source/' + Id);
  }

  
  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
